<template>
    <div slot="header">
        <el-menu :router="true" class="menu-bar" default-active="/ma/propertyMain" active-text-color="#6495ED" mode="horizontal">
            <el-menu-item index="/ma/propertyMain">Estate Matters</el-menu-item>

            <el-submenu index="2">
                <template slot="title">Reports</template>
                <el-menu-item index="/ma/access">Intercom QR Report</el-menu-item>
            </el-submenu>

            <el-menu-item index="/ma/maAccountManage" v-if="isSuper">MA/Vendor Account</el-menu-item>

            <el-menu-item index="/ma/company" v-if="isSuper">Vendor</el-menu-item>

            <el-submenu index="#" style="float: right;margin-right: 10px">
                <template slot="title"><h2 style="display: inline-block">{{userName}}</h2></template>
                <el-menu-item @click="choosePropertyName" index="#">Change Property</el-menu-item>
                <el-menu-item @click="logOut" index="#">Logout</el-menu-item>
                <el-menu-item @click="backToEazable" index="#" v-if="isEazable">Eazable</el-menu-item>
            </el-submenu>
        </el-menu>

        <el-dialog
                :visible.sync="dialogVisible"
                align="center"
                title="Choose Property"
                width="30%">
            <el-select placeholder="Please select your choice" v-model="propertyId">
                <el-option
                        :key="item.propertyId"
                        :label="item.propertyName"
                        :value="item.propertyId"
                        v-for="item in data">
                </el-option>
            </el-select>
            <el-button @click="choose(propertyId)" type="primary">Change</el-button>
        </el-dialog>
    </div>
</template>

<script>
    import MainScaffold from "@/components/MainScaffold";
    import {allProperty, updateSessionProperty} from "@/api/AuthApi";
    import {mapGetters} from "vuex/dist/vuex.esm.browser";

    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'NavBar',
        components: {MainScaffold},
        data() {
            return {
                data: [],
                active: '/ma/propertyMain',
                propertyId: {},
                userInfo: '',
                dialogVisible: false
            }
        },
        methods: {
            logOut() {
                this.$router.push('/');
                this.$store.commit('setUserInfo', null)
            },
            choosePropertyName() {
                this.dialogVisible = true;
                this.propertyId = this.userInfo.propertyId;
                allProperty(this.userInfo.userId).then(
                    res => {
                        this.data = res.data
                    }
                )
            },
            backToEazable() {
                this.$router.push('/eazable/property')
            },
            choose(pid) {
                updateSessionProperty({"propertyId": pid}).then(res => {
                    this.dialogVisible = false;
                    const reData = res.data;
                    const userInfo = this.$copy(this.$store.state.userInfo);
                    userInfo.propertyId = reData.propertyId;
                    userInfo.propertyLogo = reData.propertyLogo;
                    userInfo.propertyName = reData.propertyName;
                    this.$store.commit('setUserInfo', userInfo);
                    this.$message.success('Switching Property Success')
                })
            }
        },
        computed: mapGetters({
            userName: "getUserName",
            propertyName: 'getPropertyName',
            propertyLogo: 'getPropertyLogo',
            isSuper: 'isSuperMa',
            isEazable: 'isEazable'
        })
    }
</script>

<style scoped>
    .el-menu {
        font-weight: bold;
    }
</style>
